import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$orgSlug/admin/settings/domains")({
  // Component in lazy file for code splitting
});
